import { AmbulanceIcon, BabyStrollerIcon, BookmarkSolidIcon, BuildingCheckIcon, CalendarClockIcon, CalendarPlusIcon, CalendarReturnIcon, CalendarTimerIcon, CheckmarkIcon, ClipboardCheckIcon, ClipboardPlusIcon, ClockArrowsIcon, ComputerWithDeskIcon, DocumentPlusIcon, DocumentsIcon, EyeIcon, FamilyHouseIcon, FolderSolidIcon, HandHeartIcon, HandshakeIcon, HeartbeatIcon, HeartInHandIcon, MedicalBadgeIcon, MedicalBagIcon, MedicalExpensesIcon, PersonIcon, RefreshIcon, ShowIcon, SmileIcon, SwirlIcon, ToothIcon, UmbrellaCheckIcon, UmbrellaEditIcon, UploadDocumentIcon, UploadIcon, WheelchairIcon, } from '@digitools/honest-ui/icons';
/**
 * Maps the nav-menu API's `iconName` (CX-4027) to a honest-ui icon element.
 *
 * First pass / best guess for categories with no exact honest-ui match yet
 * (vision, accident, evidence-of-insurability) - swap in real icons
 * once they're added to honest-ui-library.
 *
 * Sticks to icons with no internal <defs>/clipPath (verified via
 * `grep -c 'clipPath id=\|linearGradient id=\|<mask ' src/icons/*.svg` in
 * honest-ui-library) - icons with a static clipPath id break when the same
 * icon renders more than once on a page (nav items reuse the same icon
 * across multiple sections), since browsers only resolve that id to one
 * DOM element. Originally picked report-add/beneficiaries/upload-doc/
 * clipboard-add/reports, all of which have this defect and rendered
 * blank on repeat instances in non-prod - swapped for defs-free
 * equivalents below. calendar-clock, clipboard-check, document-plus, and
 * documents (CX-4027) had the same clipPath defect (calendar-clock) or a
 * stray filled-circle artifact (the other three) as of 2026-09-10; both
 * are fixed as of honest-ui-library 0.1.11.
 */
export const navIconRegistry = {
    wheelchair: <WheelchairIcon />,
    'calendar-timer': <CalendarTimerIcon />,
    handshake: <HandshakeIcon />,
    smile: <SmileIcon />,
    show: <ShowIcon />,
    ambulance: <AmbulanceIcon />,
    'hand-heart': <HandHeartIcon />,
    'medical-expenses': <MedicalExpensesIcon />,
    'building-check': <BuildingCheckIcon />,
    person: <PersonIcon />,
    checkmark: <CheckmarkIcon />,
    upload: <UploadIcon />,
    'folder-solid': <FolderSolidIcon />,
    'clock-arrows': <ClockArrowsIcon />,
    'bookmark-solid': <BookmarkSolidIcon />,
    tooth: <ToothIcon />,
    swirl: <SwirlIcon />,
    'computer-with-desk': <ComputerWithDeskIcon />,
    eye: <EyeIcon />,
    'family-house': <FamilyHouseIcon />,
    heartbeat: <HeartbeatIcon />,
    'medical-badge': <MedicalBadgeIcon />,
    'medical-bag': <MedicalBagIcon />,
    'baby-stroller': <BabyStrollerIcon />,
    'calendar-plus': <CalendarPlusIcon />,
    'calendar-return': <CalendarReturnIcon />,
    'umbrella-check': <UmbrellaCheckIcon />,
    'umbrella-edit': <UmbrellaEditIcon />,
    'clipboard-plus': <ClipboardPlusIcon />,
    'heart-in-hand': <HeartInHandIcon />,
    refresh: <RefreshIcon />,
    'upload-document': <UploadDocumentIcon />,
    'calendar-clock': <CalendarClockIcon />,
    'clipboard-check': <ClipboardCheckIcon />,
    'document-plus': <DocumentPlusIcon />,
    documents: <DocumentsIcon />,
};
export function getNavIcon(iconName) {
    return iconName ? navIconRegistry[iconName] : undefined;
}
